import React from "react";
import { Hat, Tick } from "../constant/Index";

const Benefit = () => {
	return (
		<>
			{/* <!-- Benefits Sec Start Here --> */}
			<section className="benefits_sec">
				<div className="hat-circle">
					<figure>
						<img src={Hat} alt="nft-hat" className="img-fluid" />
					</figure>
				</div>
				<div className="container">
					<div className="benefit_box wow animate__animated animate__zoomIn">
						<div className="row">
							<div className="col-lg-5"></div>
							<div className="col-lg-7">
								<div className="content-wrapper">
									<div className="heading-wrapper">
										<h4>BENEFITS</h4>
										<h2>BORROW $ AGAINST YOUR NFTS</h2>
									</div>
									<p>
										Lend Me Token is designed to be used by anyone who wants to
										take advantage of blockchain technology while enjoying the
										ease of doing business in a trusted environment. Here’s what
										we can offer you when you join the drop.
									</p>
									<ul className="points">
										<li>
											<img src={Tick} alt="" className="img-fluid" />
											NFT FINANCING
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" />
											LOAN OFFERINGS
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" />
											STUDENTS LOANS
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" />
											SMES ENTERPRISE SUPPORT
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" />
											MORTGAGE
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" />
											PROFIT SHARING POOL
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" />
											CREDIT CARD SUBSCRIPTIONS
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" />
											ACCESS TO PARTNER COMMUNITIES & THEIR UTILITIES
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- Benefits Sec End Here --> */}
		</>
	);
};

export default Benefit;
